import { compact } from "core/utils"

/*
 * A clone of request from react-rb.
 * We can't import that here (and in other files in app/editor)
 * as it breaks pnpm assets build in the CI
 */
const request = async (url, options = {}) => {
  const response = await fetch(
    url,
    compact({
      credentials: "include",
      method: "GET",
      body: options.data ? JSON.stringify(options.data) : null,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name=csrf-token]")?.content
      },
      ...options
    })
  )
  return { data: await response.json(), response, status: response.status }
}

const createTrigger = async ({ url, tag }) => {
  const triggers = [
    {
      type: "Trigger::LinkClick",
      configuration: { name: url },
      initiator: { id: url }
    }
  ]

  const actions = [{ type: "Action::TagAdd", target: { name: tag.name } }]

  const rule = {
    actions,
    triggers
  }

  const response = await request("/api/v3/automations/subscriber_rules", {
    method: "POST",
    data: { rule }
  })
  return response.data
}

const updateTrigger = async (trigger, { url, tag }) => {
  const triggers = [
    {
      id: trigger.id,
      type: "Trigger::LinkClick",
      configuration: { name: url },
      initiator: { id: url }
    }
  ]

  const actions = [
    { type: "Action::TagAdd", target: { name: tag.name || tag.target_name } }
  ]

  const actionsDeleted = trigger.actions.map(action => action.id)

  const rule = {
    actions,
    triggers,
    actionsDeleted
  }

  const response = await request(
    `/api/v3/automations/subscriber_rules/${trigger.rule_id}`,
    {
      method: "PUT",
      data: { rule }
    }
  )
  return response.data
}

const getTriggers = async () => {
  try {
    const response = await request("/triggers.json?type=Trigger::LinkClick")
    if (response.response.ok) {
      return {
        triggers: response.data,
        isAuthorized: response.status !== 401
      }
    } else {
      return {
        triggers: [],
        isAuthorized: false
      }
    }
  } catch (error) {
    throw new Error(error)
  }
}

const createOrUpdateTrigger = async (triggers, id, { href, tag }) => {
  const trigger = id && triggers.find(trigger => trigger.id == id)

  const result = trigger
    ? await updateTrigger(trigger, { url: href, tag })
    : await createTrigger({ url: href, tag })

  return {
    id: id || result.rule.triggers[0].id
  }
}

export { createTrigger, updateTrigger, getTriggers, createOrUpdateTrigger }
